export default "__VITE_ASSET__1coMNVIa__"